import {
  FETCH_COLLECTIONS_START,
  FETCH_COLLECTIONS_SUCCESS,
  FETCH_COLLECTIONS_FAIL,
  FETCH_COLLECTION_FAIL,
  FETCH_COLLECTION_START,
  FETCH_COLLECTION_SUCCESS,
  CREATE_COLLECTION_START,
  CREATE_COLLECTION_FAIL,
  UPDATE_COLLECTION_START,
  UPDATE_COLLECTION_FAIL,
  DELETE_COLLECTION_FAIL,
  DELETE_COLLECTION_START,
  DELETE_COLLECTION_SUCCESS,
  CREATE_COLLECTION_SUCCESS,
} from './action';

const initialState = {
  list: [],
  selected: {},
  isLoading: true,
  isInitial: false,
  err: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
  case FETCH_COLLECTIONS_START:
  case FETCH_COLLECTION_START:
  case CREATE_COLLECTION_START:
  case UPDATE_COLLECTION_START:
  case DELETE_COLLECTION_START:
    return {
      ...state,
      isLoading: true,
    };

  case FETCH_COLLECTIONS_SUCCESS:
    return {
      ...state,
      list: payload,
      isLoading: false,
      isInitial: true,
    };

  case FETCH_COLLECTIONS_FAIL:
  case FETCH_COLLECTION_FAIL:
  case CREATE_COLLECTION_FAIL:
  case UPDATE_COLLECTION_FAIL:
  case DELETE_COLLECTION_FAIL:
    return {
      ...state,
      isLoading: false,
      isInitial: true,
      err: payload,
    };

  case FETCH_COLLECTION_SUCCESS:
    return {
      ...state,
      selected: payload,
      isLoading: false,
      isInitial: true,
    };

  case CREATE_COLLECTION_SUCCESS:
    return {
      ...state,
      list: [...state.list, { ...payload }],
      isLoading: false,
    };

  case DELETE_COLLECTION_SUCCESS:
    return {
      ...state,
      list: state.list.filter((o) => o.id !== payload),
      isLoading: false,
    };

  default:
    return { ...state };
  }
};
